import { nearest, oneDay, longer } from "../content/location";

const Location = () => {
  const distances = [
    { time: '30 minut', places: ['Piaszczystej plaży', 'Florencji', 'Pizy'] },
    { time: '60 minut', places: ['Sieny', 'San Gimignano', 'Chianti'] },
    { time: '90 minut', places: ['Montepulciano', 'Dużego ośrodka narciarskiego'] },
  ];

  return (
    <div>
      {/* HERO */}
      <div className="shell">
        <section className="hero" style={{ gridTemplateColumns: '1fr', paddingBottom: 40 }}>
          <div style={{ maxWidth: 900 }}>
            <span className="eyebrow">Region · Toskania</span>
            <h1 className="display hero-headline" style={{ fontSize: 'clamp(48px, 6vw, 96px)' }}>
              Wzgórza, które<br /><em>Toskańczycy</em> malują od wieków.
            </h1>
            <p className="hero-lede" style={{ maxWidth: 720 }}>
              Willa leży w sercu Toskanii — falujące wzgórza, samotne cyprysy, miasteczka z kamienia
              i winnice. Poniżej nasza mapa: gdzie jeść, co zwiedzić, jak dotrzeć.
            </p>
          </div>
        </section>
      </div>

      {/* DISTANCES */}
      <div style={{ background: 'var(--cream-2)' }}>
        <div className="shell">
          <section className="section">
            <div
              style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 48, borderTop: '1px solid var(--ink)', paddingTop: 48 }}
              className="features-grid"
            >
              {distances.map(d => (
                <div key={d.time}>
                  <div className="eyebrow" style={{ marginBottom: 16 }}>{d.time} do</div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                    {d.places.map(p => (
                      <div key={p} className="display" style={{ fontSize: 26 }}>{p}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* NEAREST SECTION */}
      <div className="shell">
        <section className="section">
          <div className="section-head">
            <div>
              <span className="eyebrow">Najbliższa okolica</span>
              <h2 className="display section-title">W zasięgu<br /><em>chwili</em>.</h2>
            </div>
            <p className="section-lede">
              Miejsca, do których warto skoczyć na kilka godzin — każde oddalone o mniej niż godzinę jazdy.
            </p>
          </div>
          <div
            style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }}
            className="towns-grid"
          >
            {nearest.map((card, i) => (
              <div key={card.bold}>
                <img
                  src={'/photos/toskania-miejsca/' + card.url}
                  alt={card.bold}
                  style={{ width: '100%', aspectRatio: '4/3', objectFit: 'cover', display: 'block' }}
                />
                <div className="card-label">
                  <span className="name">{card.bold}</span>
                  <span className="num">0{i + 1}</span>
                </div>
                <p style={{ margin: '10px 0 0', fontSize: 14, color: 'var(--ink-soft)', lineHeight: 1.55 }}>
                  {card.attraction}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* ONE DAY TRIPS */}
      <div style={{ background: 'var(--cream-2)' }}>
        <div className="shell">
          <section className="section">
            <div className="section-head">
              <div>
                <span className="eyebrow">Jednodniowe wycieczki</span>
                <h2 className="display section-title">Gdzie<br /><em>jechać</em>.</h2>
              </div>
              <p className="section-lede">
                Cztery kierunki na pełny dzień wyjazdowy — każdy wart co najmniej tygodnia.
              </p>
            </div>
            <div>
              {oneDay.map((card, i) => (
                <div key={card.bold} className="rest-row">
                  <div className="mono muted">{String(i + 1).padStart(2, '0')}</div>
                  <div>
                    <div className="display" style={{ fontSize: 26 }}>{card.bold}</div>
                  </div>
                  <div style={{ alignSelf: 'center' }}>
                    <img
                      src={'/photos/toskania-miejsca/' + card.url}
                      alt={card.bold}
                      style={{ width: '100%', maxWidth: 180, aspectRatio: '4/3', objectFit: 'cover', display: 'block' }}
                    />
                  </div>
                  <div style={{ color: 'var(--ink-soft)', fontSize: 14.5 }}>{card.attraction}</div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>

      {/* LONGER TRIPS */}
      <div className="shell">
        <section className="section">
          <div className="section-head">
            <div>
              <span className="eyebrow">Dłuższe wypady</span>
              <h2 className="display section-title">Dnie <em>na zewnątrz</em>.</h2>
            </div>
            <p className="section-lede">
              Dla tych, którzy chcą połączyć wypoczynek w willi z dalszą ekspedycją.
            </p>
          </div>
          <div
            style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 48 }}
            className="act-grid"
          >
            {longer.map((card, i) => (
              <div key={card.bold} style={{ borderTop: '1px solid var(--ink)', paddingTop: 20 }}>
                <img
                  src={'/photos/toskania-miejsca/' + card.url}
                  alt={card.bold}
                  style={{ width: '100%', aspectRatio: '16/9', objectFit: 'cover', display: 'block', marginBottom: 20 }}
                />
                <div className="mono olive" style={{ marginBottom: 10 }}>0{i + 1}</div>
                <h3 className="display" style={{ fontSize: 28, margin: '0 0 10px' }}>{card.bold}</h3>
                <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 14.5, lineHeight: 1.6 }}>
                  {card.attraction}
                </p>
              </div>
            ))}
          </div>
        </section>
      </div>

      {/* DOJAZD */}
      <div style={{ background: 'var(--cream-2)' }}>
        <div className="shell">
          <section className="section">
            <div className="section-head">
              <div>
                <span className="eyebrow">Dojazd</span>
                <h2 className="display section-title">Jak do <em>nas trafić</em>.</h2>
              </div>
              <p className="section-lede">
                Najbliższe lotniska to Piza (30 min), Florencja (50 min) i Rzym (3 godz.).
                Auto w Toskanii jest niezbędne — doliny nie mają dobrego transportu publicznego.
              </p>
            </div>
            <div
              style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 32 }}
              className="features-grid"
            >
              {[
                { n: '01', t: 'Samolotem', d: 'Piza, Florencja lub Rzym Fiumicino. Najwygodniej przez Pizę — 30 minut do willi.' },
                { n: '02', t: 'Autem z Polski', d: 'Ok. 14 godzin przez Wiedeń i Wenecję. Piękna trasa przez Apenniny — warto podzielić na etapy.' },
                { n: '03', t: 'Po przyjeździe', d: 'Auto w okolicy niezbędne. Wypożyczalnie na każdym lotnisku. Polecamy małe auto — droga do willi jest wąska.' },
              ].map(f => (
                <div key={f.n}>
                  <div className="mono olive" style={{ marginBottom: 14 }}>{f.n} / 03</div>
                  <h3 className="display" style={{ fontSize: 28, margin: '0 0 10px' }}>{f.t}</h3>
                  <p style={{ margin: 0, color: 'var(--ink-soft)', fontSize: 14.5, lineHeight: 1.6 }}>{f.d}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Location;
